"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCompoundParser = void 0;
var parsers_1 = require("./parsers");
var compoundParsersMap = {
    'box-shadow': parsers_1.parseBoxShadowCompound,
    'text-shadow': parsers_1.parseTextShadowCompound,
};
var getCompoundParser = function (prop) {
    var getParser = compoundParsersMap[prop];
    return getParser();
};
exports.getCompoundParser = getCompoundParser;
//# sourceMappingURL=compound-mapper.js.map